import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppStatic, ContentService, TypableService } from '../_core';
import { LcpHelper } from '../_core/_helpers/lcp-helper';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';



// animations inspired by: 
// https://www.youtube.com/watch?v=HSxQbGXDo3U&ab_channel=BrianTreese
// https://stackblitz.com/edit/stackblitz-starters-3ufzct?file=src%2Fsign-up-form%2Fsign-up-form.component.ts

@Component({
  selector: 'lcp-collections',
  templateUrl: './collections.component.html',
  styleUrls: ['./collections.component.scss'],
})
export class CollectionsComponent implements OnInit, OnDestroy {

  slug = 'collections'
  content: any
  fields: any

  hoveringCollectionIndex: number

  typableIntersectionObserver: any

  metadataSlugs = [
    'collections-page-collection-description-length-max',
    'learn-more-arrow-1'
  ]
  metadata: any = {}
  linkPlaceholder: string = 'show more'
  descriptionPlaceholder: string
  learnMoreArrowMedia: any

  destroy$: Subject<boolean> = new Subject<boolean>();


  constructor(
    private router: Router,
    public contentService: ContentService,
    public lcpHelper: LcpHelper,
    public typableService: TypableService
  ) { }

  ngOnInit(): void {
    this.getMetadata()
    this.getPage()
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  initIntersectionObservers() {
    if (!AppStatic.isBrowser) return
    const mobileWrappers = document.getElementsByClassName('typable-wrapper-mobile')
    if (!mobileWrappers) return console.log('!mobileWrappers')
    const mobileWrappersArray = Array.prototype.slice.call( mobileWrappers )

    for (const [i, el] of mobileWrappersArray.entries()) {      
      const mobileCollectionElement = el.querySelector('.typable-container')
      // console.log('CHECK mobileCollectionElements', mobileCollectionElement)
      const block = this.fields['sections'][0].fields['items'][i]
      if (!block) console.log('ERR: initIntersectionObserver !block')
      this.typableIntersectionObserver = this.typableService.initIntersectionObserver(mobileCollectionElement, { block: block, removeCursorAfterTyping: true })
    }
  }

  getMetadata() {
    this.contentService.getMetadata({'fields.slug[in]': this.metadataSlugs.join(',') }) // { slug: 'scroll-arrow-icon' })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (meta: any) => {
        try {
          if (!meta.items[0]) return console.log('ERR: !meta', meta)
          
          for (let item of meta.items) {
            let val
            switch (item.fields['type']) {
              case 'other':
              case 'string': val = item.fields['value']; break;
              case 'number': val = +item.fields['value']; break;
              case 'media': val = item.fields['media']; break;
              case 'items': val = item.fields['items']; break;
            }
            this.metadata[item.fields['slug']] = val // NOTE: ALL NUMBERS this time
          }
          const descriptionPlaceholderArray = Array(this.metadata['collections-page-collection-description-length-max']).fill('x')
          this.descriptionPlaceholder = descriptionPlaceholderArray.join('')
          this.learnMoreArrowMedia = this.metadata['learn-more-arrow-1'][0]
          // console.log('CHECK: meta', meta, this.learnMoreArrowMedia, this.metadata) // this.descriptionPlaceholder, this.metadata)
        } catch {
          console.log('ERR: getMetadata', meta)
        }
      }
    })
  }

  getPage(){
    this.contentService.getPage({ 'fields.slug': this.slug })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (content) => {
        // this.content = content
        if (!content) return console.log('!content', content)
        this.fields = content.items[0].fields
        // console.log('fields', this.fields)
        setTimeout(() => {
          this.initIntersectionObservers()
        }, 500)
      }
    });
  }

  async handleHoverCollection(params={}) {
    // if (this.hoveringCollectionIndex == params['index']) return // console.log('isHoveringCollectionIndex', this.hoveringCollectionIndex, params['index'])
    // this.hoveringCollectionIndex = params['index']
    

    const link = this.lcpHelper.linkFromBlock(params['block'])
    if (!link) return console.log('ERR: !link', params)

    const evt = params['event']
    const container = evt && evt.target && evt.target.closest('.typable-container')
    const typableTextElement = container.querySelector('.typable-text')
    const typeParams = { 
      event: evt, 
      text: link['text'], 
      delay: 50, 
      minDelay: 10,
      typableTextElement: typableTextElement } // removeCursorAfterTyping: true

    this.typableService.typeText(typeParams)
  } 


  // async handleHoverService(params={}) {
  //   const block = params['block']
  //   delete params['block']
  //   const text = documentToPlainTextString(block.fields['body']) + "  "

  //   const evt = params['event']
  //   const container = evt && evt.target && evt.target.closest('.typable-container')
  //   const typableTextElement = container.querySelector('.typable-text')
  //   const textParams = Object.assign({}, params, { text: text, typableTextElement: typableTextElement })
  //   // console.log('TODO: link', block)
  //   const wasTyped = await this.typableService.typeText(textParams)
  //   // console.log('wasTyped', wasTyped)
  //   if (!wasTyped) return // console.log('CHECK !wasTyped')

  //   const linkAddress = block.fields['linkAddress']
  //   const linkText = block.fields['linkText']
  //   if (linkText && linkAddress) {
  //     const typableTextElement = container.querySelector('.typable-link')
  //     const linkParams = Object.assign({}, params, { link: { text: linkText, address: linkAddress }, typableTextElement: typableTextElement, repeatable: true })
  //     this.typableService.typeText(linkParams)
  //   }
  // } 

  handleBlurCollection(params={}) {
    const target = params['event'].target
    const repeatables = target.querySelectorAll('.typable-repeatable')
    // console.log('TODO: handleBlurColl', repeatables)
    this.typableService.resetRepeatables(repeatables)
  }

  handleSelectCollection(block) {
    // console.log('TODO: handleSelectCollection', block)
    const link = this.lcpHelper.linkFromBlock(block)
    if (!link) return
    this.router.navigate([link.address])
  }
}
